/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetAudits200Response,
} from '../models/index';
import {
    GetAudits200ResponseFromJSON,
    GetAudits200ResponseToJSON,
} from '../models/index';

export interface GetAuditsRequest {
    search?: string;
    page?: number;
    per_page?: number;
    client_id?: number;
    user_id?: number;
}

/**
 * 
 */
export class AuditsApi extends runtime.BaseAPI {

    /**
     * Get list of audits
     */
    async getAuditsRaw(requestParameters: GetAuditsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAudits200Response>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['per_page'] != null) {
            queryParameters['per_page'] = requestParameters['per_page'];
        }

        if (requestParameters['client_id'] != null) {
            queryParameters['client_id'] = requestParameters['client_id'];
        }

        if (requestParameters['user_id'] != null) {
            queryParameters['user_id'] = requestParameters['user_id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/audits`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAudits200ResponseFromJSON(jsonValue));
    }

    /**
     * Get list of audits
     */
    async getAudits(requestParameters: GetAuditsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAudits200Response> {
        const response = await this.getAuditsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
